import {
  gql,
  OperationVariables,
  QueryHookOptions,
  useLazyQuery,
} from '@apollo/client';
import { IGetAlertMetadata } from './types';

export const GET_ALERT_METADATA_SURICATA_INVESTIGATE_ALERT = gql`
  query getAlertMetadataSuricataInvestigateAlert(
    $items: [GetAlertMetadataInput]!
  ) {
    getAlertMetadata(items: $items) {
      metadata {
        chatbot_chats {
          suri_investigate_alert
        }
      }
    }
  }
`;

export const useGetAlertMetadataSuricataInvestigateAlert = (
  options: QueryHookOptions<IGetAlertMetadata, OperationVariables>,
) =>
  useLazyQuery<IGetAlertMetadata>(
    GET_ALERT_METADATA_SURICATA_INVESTIGATE_ALERT,
    options,
  );
